var isContextPathNull = true;
var isProduction = process.env.NODE_ENV.trim() === 'production'

var contextPath = '';
var domain = '';
//var port = '7200';
var port = '';

if (isContextPathNull) {
  contextPath = '';
} else {
  contextPath = 'cdlmdm';
}

  domain = window.BaseConfigInfo.baseSSO.domainName;

if (port !== '') {
  domain = domain + ':' + port + '/';
} else {
  domain = domain + '/';
}

if (contextPath !== '') {
  domain = domain + contextPath + '/';
}

// export default domain

export const baseUrl = domain;  // 基础路径
export const baseAcs = `${domain}mdm-common`; // ACS 微服务
export const baseStore = `${domain}mdm-store`; // Store 微服务
export const baseBPM = `${domain}mdm-product-price`; // BPM 微服务
export const baseSC = `${domain}goldenpipe-special-channel`; // special channel 微服务
export const baseDSTC = `${domain}goldenpipe-dstc`; // DSTC 微服务
export const baseNonSale = `${domain}goldenpipe-non-sale`; // NonSale 微服务
export const baseHKTW = `${domain}goldenpipe-hktw`; // HKTW 微服务
export const baseMDReadiness = `${domain}goldenpipe-md-readiness-sidecar`; // MDChecking 微服务
export const baseSmile = `${domain}goldenpipe-smile-sidecar`; // MDChecking 微服务
export const baseMDM = `${domain}mdm-dataqualityprocess`; // MDM 微服务
export const baseCOMM = `${domain}mdm-common`; // COMM 微服务

export const goldenpipeServer = [
  "mdm-common",
  "mdm-store",
  "mdm-product-price",
  "goldenpipe-special-channel",
  "goldenpipe-dstc",
  "goldenpipe-non-sale",
  "goldenpipe-hktw",
  "goldenpipe-md-readiness-sidecar",
  "goldenpipi-smile",
  "mdm-dataqualityprocess",
  "mdm-dataselfserveappcontrol",
]; // goldenpipe 微服务汇总, 请求拦截会用到





// WEBPACK FOOTER //
// ./src/assets/js/base-url.js